import useAuth from 'hooks/useAuth'
import { useLocation, Navigate } from 'react-router-dom'

const Auth = ({ children }) => {
	
	const auth = useAuth()
	const location = useLocation()
	const params = new URLSearchParams(location.search)

	if (!auth.isLogin) {
		console.log(location.pathname);

		let state = {
			from: location.pathname
		}

		if (params.get("push")) {
			state = {
				...state,
				push: params.get("push"),
				no: ""
			}

			if (params.get("no")) {
				state = {
					...state,
					no: params.get("no")
				}
			}
		}

		return <Navigate to="/member/login" replace state={state} />
		// return <Login from={location.pathname} />
	} else {
		return children
	}
}

export default Auth
